import SectionHeader  from "../components/SectionHeader";
import TextWrapper from "./TextWrapper";
import VariantWrapper from "./VariantWrapper";
import { CAROUSEL_ITEM_PADDING } from "../PosterChapter.constants";
import ServiceHubPosterChapterData from '../PosterChapter.interface';
import { motion } from 'framer-motion';
import { NIKE_EASE } from '../../../../rise/constants/nikerise';
import MediaRenderer from '../../../../core/components/MediaRenderer';

export default function LayoutVariant5(props: ServiceHubPosterChapterData) {
    const { subtitle, is_show_date, logo } = props;

    return (
        <VariantWrapper data={props}>
            <TextWrapper style={{ color: 'white' }}>
                <SectionHeader title={subtitle} isShowDate={is_show_date} animated animationOffset={1} />
            </TextWrapper>

            <motion.div
                style={{
                    position: 'absolute',
                    padding: `${CAROUSEL_ITEM_PADDING}vh`,
                    bottom: 0,
                    left: 0,
                }}
                initial={{ opacity: 0 }}
                animate={{
                    opacity: 1,
                    transition: {
                        ease: NIKE_EASE,
                        duration: 1.5,
                        delay: 1.5,
                    },
                }}
            >
                <MediaRenderer media={logo} />
            </motion.div>
        </VariantWrapper>
    )
}
